$(document).on('turbo:load', () => {
  $('#user_insurance_information_address1, #user_insurance_information_address2, #user_insurance_information_city, #user_insurance_information_state, #user_insurance_information_zip').on("change, keyup", (event) => {
    if (
      $('#user_insurance_information_address1').val().length > 0 
      && $('#user_insurance_information_city').val().length > 0 
      && $('#user_insurance_information_state').val().length > 0 
      && $('#user_insurance_information_zip').val().length > 0 
      ) {
      $('#submit-new-user-insurance-information-btn').prop("disabled", false);
    } else {
      $('#submit-new-user-insurance-information-btn').prop("disabled", true);
    }
  });
});